import Layout from '@/views/Layout'

import layoutRouteConfig from './layout-route-config'

const genPath = (name, params = []) => {
  if (!params || params.length == 0) {
    return name
  }
  const paramsPath = params.map(p => `:${p}`).join('/')
  return `${name}/${paramsPath}`
}

const layoutRoutes = layoutRouteConfig.map(config => ({
  path: `/${config.name}`,
  name: config.name,
  meta: config.meta,
  component: Layout,
  redirect: config.redirect,
  hidden: config.hidden === true,
  noShowingChildren: config.noShowingChildren === true,
  children: config.children ? config.children.map(child => ({
    name: `${config.name}-${child.name}`,
    path: genPath(child.name, child.params),
    component: async () => {
      const com = await child.component()
      com.default.name = `${config.name}-${child.name}`
      return com
    },
    meta: child.meta,
    redirect: child.redirect,
    hidden: child.hidden === true,
    noShowingChildren: child.noShowingChildren === true,
    children: child.children ? child.children.map(childSec => ({
      name: `${config.name}-${child.name}-${childSec.name}`,
      path: genPath(childSec.name, childSec.params),
      component: async () => {
        const comSec = await childSec.component()
        comSec.default.name = `${config.name}-${child.name}-${childSec.name}`
        return comSec
      },
      meta: childSec.meta,
      redirect: childSec.redirect,
      hidden: childSec.hidden === true,
      noShowingChildren: childSec.noShowingChildren === true,
      children: childSec.children ? childSec.children.map(childThi => ({
        name: `${config.name}-${child.name}-${childSec.name}-${childThi.name}`,
        path: genPath(childThi.name, childThi.params),
        component: async () => {
          const comThi = await childThi.component()
          comThi.default.name = `${config.name}-${child.name}-${childSec.name}-${childThi.name}`
          return comThi
        },
        meta: childThi.meta,
        redirect: childThi.redirect,
        hidden: childThi.hidden === true,
        noShowingChildren: childThi.noShowingChildren === true
      })): undefined
    })): undefined
  })) : undefined
}))

export const routes = [{
    name: 'login',
    path: '/login',
    component: () => import('@/views/Login'),
    hidden: true
  },
  {
    name: '404',
    path: '/404',
    component: () => import('@/views/ErrorPage/404'),
    hidden: true
  },
  {
    name: '401',
    path: '/401',
    component: () => import('@/views/ErrorPage/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    name: 'dashboard',
    redirect: '/order/order',
  //   children: [
  //     {
  //     name: 'dashboard',
  //     path: 'dashboard',
  //     component: () => import('@/views/Dashboard'),
  //     meta: { title: 'Dashboard', icon: 'dashboard', noCache: true }
  //   }
  // ]
  },
  { path: '*', redirect: '/404', hidden: true },
  ...layoutRoutes
]
